import {chatauthurl, wxLogin, wefunstatisticsSave, getCustomerLimit} from "@/server/api.js";
import { Toast } from "vant";
import store from "@/store/index"
import moment from "moment"
import {changeFileType} from "@/views/fastReply/js/config";

export function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

// 格式化query参数
export const getParams = (search) => {
  let params = {};
  if (search.indexOf("?") === 0 && search.indexOf("=") > 1) {
      let paramArray = unescape(search).substring(1, search.length).split("&");
      if (paramArray.length > 0) {
          paramArray.forEach(function (currentValue) {
              params[currentValue.split("=")[0]] = currentValue.split("=")[1];
          });
      }
  }
  return params;
}

/*
 *  格式化query参数
 */
export function urlEncode(param, key, encode) {
	if (param == null) return ''
	let paramStr = ''
	let t = typeof(param)
	if (t === 'string' || t === 'number' || t === 'boolean') {
		paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param)
	} else {
		for (let i in param) {
			let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
			paramStr += urlEncode(param[i], k, encode)
		}
	}
	return paramStr
}

//获取地址栏url后的参数值
export function getUrlParam(key) {
	let href = window.location.href;
	let url = href.split("?");
	if (url.length <= 1) {
		return "";
	}
	let params = url[1].split("&");

	for (let i = 0; i < params.length; i++) {
		let param = params[i].split("=");
		if (key == param[0]) {
			return param[1];
		}
	}
}

/*
 *  防抖
 */
export function debounce(fun, delay) {
	// debugger
	let timeout = null
	return function() {
		if(timeout !== null) clearTimeout(timeout)
		let callNow = !timeout
		timeout = setTimeout(()=>{
			timeout = null
		}, delay)
		console.log(callNow)
		if (callNow) {
			console.log(this)
      fun.apply(this)
    }
	}
}

export function timeClick(fn, delay) {
	let last = 0
  return function () {
      let context = this
      // 
      let args = arguments
      let now = +new Date()
      if (now - last >= delay) {
          last = now;
          fn.apply(context, args);
      }
    }
}

export function getDateTime(value) {
	if (value) {
		return new Date(value).getTime();
	} else {
		return "";
	}
}

export function formattime (time) {
	if (time) {
		return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
	}
	return "";
}

export function formatDate (time) {
	if (time) {
		return moment(new Date(time)).format("YYYY-MM-DD");
	}
	return "";
}

export function addressBar (name, windowurl) {
	if (
		!(window.location.search && getParams(window.location.search).code)
	) {
		linkAuth(windowurl);
	}
	else {
		toLogin();
	}
}

export async function linkAuth (windowurl) {
	let res = await chatauthurl({ authurl: windowurl });
      if (res.code == "200") {
        window.location.href = res.data;
      }
}

export async function pageLimit(limitName,callback){
	if(localStorage.getItem('token')){
	// if('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJIb3VUaWFuUWluIiwiZXhwIjoxNjgxODYxMjUxfQ.CfMeUVZmVnKoxpyU_L5hMciaNuiCiAu77KB4SgytmHs'){
		let userId = localStorage.getItem("userid");
		let superAdmin = parseInt(
			JSON.parse(localStorage.getItem("userInfo")).superAdmin
		);
		let params = {
			userId: userId,
			superAdmin: superAdmin,
		};
		let res = await getCustomerLimit(params);
		if (res.code !== "200") return Toast.fail(res.msg);
		if (res.data.length > 0) {
			if (res.data.includes(limitName)){
				callback(true);
			}else{
				callback(false);
			}
		}
	}else{
		let windowurl =
			window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/index";
		addressBar("token", windowurl);
	}
}

export async function wefunstatistics(type,url){
	let res = await wefunstatisticsSave ({
		type:type,
		url:url
	});
	if(res.code !=='200'){
		await wefunstatistics(type,url);
	}
	return res;
}

export async function toLogin () {
	let code = getParams(window.location.search).code; //记得放开
      let res = await wxLogin({ code: code });
      if (res.code !== "200") return Toast.fail(res.msg);
			localStorage.setItem("token", res.data.token);
			localStorage.setItem("userid", res.data.user.userid);
			localStorage.setItem("zsUserId", res.data.user.zsUserId);
			localStorage.setItem("userInfo", JSON.stringify(res.data.user));
			localStorage.setItem("superAdmin", res.data.user.superAdmin);
			store.commit('setTokenFlag', true)
			window.location.href =  window.location.href.split("?")[0];
			// if(location.href.split("?")[0].includes('info')){
			//
			// }else{
			//
			// }
}

export async function shareListFun(obj){
	let msgType = obj.msgType == "link" ? "news" : obj.msgType;
	let contentObj = await changeFileType(obj, msgType);
	if (contentObj) {
		wx.invoke(
			"sendChatMessage",
			{
				msgtype: msgType,
				enterChat: false,
				[msgType]: contentObj,
			},
			function (res) {
				if (res.err_msg == "sendChatMessage:ok") {
					//发送成功
					Toast.success("发送成功");
				}else{
					Toast.fail(res.err_msg)
				}
			}
		);
	}
}

export function handleShowMore(e) {
	e.stopPropagation();
	let current = e.target;
	if (current.innerHTML.includes("收起")) {
		current.innerHTML = "展开";
		current.previousElementSibling.classList.add("hide-text");
	} else {
		current.innerHTML = "收起";
		current.previousElementSibling.classList.remove("hide-text");
	}
}

export function mixSort(_a, _b) {
  const reg = /[a-zA-Z0-9]/
  const a = _a.toString()
  const b = _b.toString()
  if (reg.test(a[0]) || reg.test(b[0])) {
    if (a > b) {
      return 1
    } else if (a < b) {
      return -1
    } else {
      return 0
    }
  } else {
    return a.localeCompare(b)
  }
}

